import { type QueryClient, useMutation } from '@tanstack/react-query';

import { type AuditService } from '#apps/client-web/features/audit/services/audit';
import { AUDITS_QUERY_KEY } from '#apps/client-web/features/audit/types/react-query';

export const useUpdateAuditMutation = ({
  auditService,
  queryClient,
}: {
  auditService: AuditService;
  queryClient: QueryClient;
}) =>
  useMutation(
    {
      mutationKey: [AUDITS_QUERY_KEY],
      mutationFn: auditService.update.bind(auditService),
    },
    queryClient,
  );
